<template>
  <div id="page-wrap" v-if="loggedIn">
    <PageHeader :activeLink="'home'"></PageHeader>
    <div class="container content-wrap">
      <div class="row">
        <div class="hidden-xs col-md-10 col-md-offset-1">
          <QuickLinks></QuickLinks>
        </div>
        <section class="payment-type col-md-offset-1 col-md-10">
          <header class="paymentHeader row">
            <div class="col-xs-12">
              <div class="col-xs-1 text-right">
                <a @click="$router.go(-1)" class="back-link">
                  <img src="/static/images/svgs/back-blue.svg" alt="< Go Back" />
                </a>
              </div>
              <div class="hidden-xs hidden-sm col-xs-11">
                <h2>Select Payment Method</h2>
              </div>
            </div>
          </header>
          <Toast
            :classNames="'toast-bordered text-center toast-warning'"
            :text="
              'We are currently experiencing payment issue with HDFC credit cards. Please choose another payment method.'
            "
          ></Toast>
          <div v-if="paymentsLoaded" class="hidden-xs hidden-sm paymentContent col-md-12">
            <div class="paymentModes col-md-12">
              <label
                class="payMode text-left"
                v-for="(mode, index) in paymentTypes"
                :key="mode.displayName"
              >
                <span class="chkWrapper">
                  <input
                    type="radio"
                    v-model="selected_mode"
                    name="paymentType"
                    :value="mode.methodKey"
                  />
                  <span class="checkmark selected"></span>
                </span>
                {{ mode.displayName }}
              </label>
              <!--payMode-->
            </div>
            <!--paymentModes-->
          </div>
          <!--paymentContent-->
          <div class="amountWrapr col-md-12">
            <div class="amountText col-xs-6 text-left">total amount</div>
            <div class="amount col-xs-6 text-right">
              <span></span>
              {{ txnAmount | formatCurrency }}
            </div>
          </div>
          <!--amountWrapr-->
          <button
            type="button"
            class="hidden-xs hidden-sm btn btn-blue btn-block"
            :disabled="selected_mode == ''"
            @click="proceedToPayment"
            style="padding:16px 0 10px 0;text-transform: capitalize; text-align: center;"
            name="button"
          >Make Payment</button>
        </section>
        <section class="col-xs-12 visible-xs visible-sm">
          <div class="paymentContent paymentContentMobile col-md-12">
            <h4
              class="col-xs-12"
              style="color: #b0bfd9; font-size:14px; font-weight:normal"
            >SELECT A PAYMENT MODE</h4>
            <div class="paymentModes col-xs-12">
              <label
                class="payMode text-left"
                v-for="(mode, index) in paymentTypes"
                :key="mode.displayName"
              >
                <div class="chkWrapper">
                  <input
                    type="radio"
                    v-model="selected_mode"
                    name="paymentTypeMobile"
                    :value="mode.methodKey"
                  />
                  <span class="checkmark selected"></span>
                </div>
                {{ mode.displayName }}
              </label>
            </div>
            <button
              type="button"
              class="visible-xs visible-sm btn btn-blue btn-block"
              :disabled="selected_mode == ''"
              @click="proceedToPayment"
              style="padding:10px 0 10px 0;text-transform: capitalize; text-align: center;"
              name="button"
            >Make Payment</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from "./Toast/index";
import PageHeader from "./PageHeader/index";
import { mapGetters } from "vuex";
import QuickLinks from "./QuickLinks/index";
export default {
  name: "payment-type",
  data() {
    return {
      query: {},
      selected_mode: "",
      txnAmount: 0,
      paymentsLoaded: false
    };
  },
  components: { PageHeader, QuickLinks, Toast },
  computed: {
    ...mapGetters(["paymentTypes", "loggedIn"])
  },
  mounted() {
    /* this.$store.dispatch('paymentType').finally(()=>{
      this.paymentsLoaded = true
    }) */
    this.$store.dispatch("paymentType").then(resp => {
      this.paymentsLoaded = true;
    });

    this.query = JSON.parse(localStorage.getItem("paymentQuery"));
    this.txnAmount = localStorage.getItem("txnAmount");
    this.$store.dispatch("getUser").then(response => {
      response.version === "epaylaterv2"
        ? this.$router.push({ name: "Dashboard" })
        : "";
    });
  },
  methods: {
    proceedToPayment() {
      this.query.paymentMethod = this.selected_mode;
      this.$store.dispatch("getUser").then(response => {
        response.version === "epaylaterv2"
          ? this.$router.push({ name: "Dashboard" })
          : this.$store.dispatch("makePayment", this.query);
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";

#page-wrap {
  background: #f5f6f7;
}

a.back-link {
  display: block;
  line-height: 88px;
  cursor: pointer;
}

.chkWrapper {
  width: 50px;
  float: left;
  position: relative;
  input[type="radio"] {
    position: relative;
    opacity: 0;
    cursor: pointer;
  }
  span.checkmark {
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 25px;
    width: 25px;
    background-color: #eee;
    display: inline-block;
    border-radius: 50%;
  }
  input[type="radio"]:checked ~ .checkmark {
    background-color: #59cd90;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  input[type="radio"]:checked ~ .checkmark:after {
    display: block;
  }
  .checkmark:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

.toast {
  margin: 24px 0 24px 90px;
  display: inline-block;
}

.payment-type {
  border-radius: 4px;
  overflow: hidden;
  background-color: #ffffff;
  padding-bottom: 0px;
  @media screen and (min-width: $md) {
    padding-bottom: 32px;
  }
  .paymentHeader {
    height: 88px;
    border-radius: 3px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.5px;
    text-align: left;
    color: #4b5566;
    text-transform: capitalize;
    z-index: 1;
    @media screen and (min-width: $md) {
      box-shadow: 0 2px 0px rgba(0, 0, 2px, 0.05);
    }
    h2 {
      line-height: 88px;
      margin: 0;
      font-size: 20px;
    }
  }
  .midContent {
    padding: 2px 13px 14px 40px;
    background: url("/static/images/pngs/coupans.png") no-repeat;
    background-position: 4px 6px;
    display: inline-block;
    width: 100%;
    a {
      float: left;
      font-family: Overpass;
      font-size: 13px;
      font-weight: 600;
      color: #377cfd;
      padding-top: 6px;
    }
  }
  .amountWrapr {
    padding: 12px 15px 31px 40px;
    display: inline-block;
    width: 100%;
    .amountText {
      font-family: Overpass;
      font-size: 14px;
      letter-spacing: -0.2px;
      color: #718099;
      text-transform: capitalize;
      float: left;
      padding-top: 7px;
    }
    .amount {
      font-family: Overpass;
      font-size: 20px;
      letter-spacing: -0.5px;
      color: #4b5566;
      float: left;
      span {
        display: inline-block;
        width: 13px;
        font-size: 21px;
      }
    }
  }
}

.paymentContent {
  padding: 25px 0;

  .paymentModes {
    padding: 0;
    margin-bottom: 50px;
    display: inline-block;
    width: 100%;
    text-transform: capitalize;

    .payMode {
      border-radius: 10px 10px;
      width: 175px;
      cursor: pointer;
      float: left;
      border: 1px solid #f7f8f8;
      line-height: 80px;
      margin-right: 9px;
      margin-bottom: 9px;
      .paymentStatus {
        background: url("/static/images/pngs/radio.png") no-repeat;
        height: 20px;
        width: 20px;
        float: left;
      }
      .paymentIcon {
        width: 80px;
        float: left;
        object-fit: contain;
      }
      .icon-paytm {
        background: url("/static/images/pngs/paytm1.png") no-repeat;
        height: 27.1px;
        position: relative;
        left: 16px;
        bottom: 2px;
      }
      .icon-bhim {
        background: url("/static/images/pngs/bhim1.png") no-repeat;
        height: 46.9px;
        position: relative;
        left: 15px;
        bottom: 14px;
      }
      .icon-mobikwik {
        background: url("/static/images/pngs/mobikwik1.png") no-repeat;
        height: 25.8px;
        position: relative;
        left: 11px;
        bottom: 2px;
      }
      .icon-payzapp {
        background: url("/static/images/pngs/payzapp1.png") no-repeat;
        height: 28px;
        position: relative;
        left: 11px;
        bottom: 3px;
      }
      .icon-jiomoney {
        background: url("/static/images/pngs/jio1.png") no-repeat;
        height: 23px;
        position: relative;
        left: 13px;
        bottom: 3px;
      }
      .icon-phonepay {
        background: url("/static/images/pngs/phonepay1.png") no-repeat;
        width: 72px;
        height: 26.4px;
      }
    }
  }

  &.paymentContentMobile {
    .paymentModes {
      margin-bottom: 20px;
      .payMode {
        display: inline-block;
        box-sizing: border-box;
        line-height: 60px;
        margin: 10px 2.5%;
        background: #fff;
        width: 45%;
      }
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/PaymentType.vue